export default "__VITE_ASSET__DIyUHhMD__"